import { render } from "./PostTypes.vue?vue&type=template&id=358e7548"
import script from "./PostTypes.vue?vue&type=script&lang=js"
export * from "./PostTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__